<section
  class="shop-more"
  *ngIf="
    !loading &&
    items.length > 0
  "
>

  <h2>
    {{ title || t('shopGetMore') }}
  </h2>


  <div class="shop-grid">

    <article
      class="shop-card"
      *ngFor="
        let item of items
      "
    >

      <div class="shop-text">

        <h3>
          {{ item.title }}
        </h3>


        <p
          *ngIf="item.description"
        >
          {{ item.description }}
        </p>

      </div>


      <div class="shop-visual">

        <img
          *ngIf="item.imageUrl"
          [src]="item.imageUrl"
          [alt]="item.title"
          loading="lazy"
          decoding="async"
          (error)="onImageError($event)"
        >


        <span
          class="fallback-icon"
          *ngIf="!item.imageUrl"
        >
          🛍️
        </span>


        <span
          class="visual-badge"
          *ngIf="item.badgeText"
        >
          {{ item.badgeText }}
        </span>

      </div>

    </article>

  </div>

</section>